module.exports = __webpack_public_path__ + "static/media/achievements.f633798d.svg";